<template>
  <div class="text-[14px] leading-[20px] text-gray-800">
    <UpgradeToProCallout v-if="isBasic" class="mb-5">
      Enable privacy/invite controls and other features
    </UpgradeToProCallout>

    <div :class="{ 'pointer-events-none opacity-50': isBasic }">
      <p class="mb-6">
        Choose the default visibility for copyrights you add to Dacr. This will
        not affect any files you have already added.
      </p>

      <div class="flex items-start justify-between gap-4">
        <div>
          <div class="mb-1 flex items-center font-medium">
            <LockIcon class="mr-2 size-5 text-gray-800" />
            <span>Make file private</span>
          </div>
          <p class="text-gray-500">
            Only you or those you invite can see the files you add and their
            descriptions.
          </p>
        </div>
        <Toggle
          v-model="isPrivate"
          :size="isDesktopLayout ? 'md' : 'lg'"
          :disabled="isBasic"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Toggle } from '@dacr/library'
import { LockIcon } from '@dacr/icons'
import UpgradeToProCallout from '@/features/billing/components/UpgradeToProCallout.vue'
import { useDevice } from '@/shared/composables/useDevice'

defineProps<{
  isBasic: boolean
}>()

const { isDesktopLayout } = useDevice()

const isPrivate = defineModel<boolean>({ required: true })
</script>
